import socket from '@/plugins/socket'
import ScoreTypeHelper from '@/store/model/sport/sport/ScoreTypeHelper'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas.forEach(item => { state.list.push(new ScoreTypeHelper(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportScorehelper', 'Sport/ScoreTypeHelper/set') }
  },
  getters: {
    search: (state) => (roundTypeId, eventUnitId, disciplineId) => state.list.filter((item) => {
      return (item.eventUnitId === eventUnitId || item.disciplineId === disciplineId) && (item.roundTypeId === null || item.roundTypeId === roundTypeId)
    })
  }
}
